/* eslint-disable */
require('./basket')
require('./box')
require('./dish')
require('./eat')
require('./help')
require('./logistics')
require('./orderlina')
require('./picante')
require('./placeholders')
require('./ride')
require('./services')
require('./shop')
require('./tuk-round')
require('./tuk-word')
